import { render } from "./KpiComponent.vue?vue&type=template&id=06e75f48&scoped=true"
import script from "./KpiComponent.vue?vue&type=script&lang=js"
export * from "./KpiComponent.vue?vue&type=script&lang=js"

import "./KpiComponent.vue?vue&type=style&index=0&id=06e75f48&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e75f48"]])

export default __exports__